import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import { useSportConfig } from '../../hooks/useSportConfig';
import { useSweep } from '../../hooks/useSweep';
import {
    getDayOfTheMonth,
    getDayOfWeek,
    getFormattedTime,
    getTheMonth
} from '../../helpers/dateTimeHelpers';

const PreEventInfo = ({ children }) => {
    const { config } = useSportConfig();
    const { sweep } = useSweep();

    const { name: sweepName, prize, closeDate, event } = sweep;
    const { name: eventName, startDate } = event;

    const { selectionNoun, eventNoun, winCondition } = config.labels;

    const closeTime = getFormattedTime(closeDate);
    const closeWeekday = getDayOfWeek(closeDate);
    const closeDayOfMonth = getDayOfTheMonth(closeDate);
    const closeMonth = getTheMonth(closeDate);

    const eventTime = getFormattedTime(startDate);
    const eventWeekday = getDayOfWeek(startDate);
    const eventDayOfMonth = getDayOfTheMonth(startDate);
    const eventMonth = getTheMonth(startDate);

    const rules = [
        <>
            Enter the <strong>{sweepName}</strong> competition by{' '}
            <strong>{closeTime}</strong> on {closeWeekday} {closeDayOfMonth}{' '}
            {closeMonth}, and we will draw you a {selectionNoun} at random.
            It&apos;s completely <strong>free to enter.</strong>
        </>,
        <>
            If your {selectionNoun}{' '}
            <strong>{winCondition(eventTime, eventName, eventNoun)}</strong> on{' '}
            {eventWeekday} {eventDayOfMonth} {eventMonth}, you will be entered
            into a Prize Draw to win <strong>{prize}!</strong>
        </>
    ];

    return (
        <Styled.Wrapper>
            <Styled.RulesWrapper>
                <Styled.Rules>
                    <Styled.RulesTitle>How does it work?</Styled.RulesTitle>
                    {/* eslint-disable react/no-array-index-key */}
                    {rules.map((ruleContent, index) => (
                        <Styled.Rule key={`rule-${index}`}>
                            <Styled.RulesNumber>{index + 1}</Styled.RulesNumber>{' '}
                            {ruleContent}
                        </Styled.Rule>
                    ))}
                    {/* eslint-enable react/no-array-index-key */}
                </Styled.Rules>
            </Styled.RulesWrapper>
            {children}
        </Styled.Wrapper>
    );
};

PreEventInfo.propTypes = {
    children: PropTypes.node.isRequired
};

export default PreEventInfo;
